import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { NotificationDto } from './types';

/** The session user's most recent notifications (own feed only). */
export const fetchNotifications = async (): Promise<NotificationDto[]> => {
  const res = await apiClient.get<ApiSuccess<NotificationDto[]>>('/notifications');
  return res.data.data;
};

/** Unread count for the bell badge. Tolerant of an unexpected envelope. */
export const fetchUnreadCount = async (): Promise<number> => {
  const res = await apiClient.get<ApiSuccess<{ count: number }>>('/notifications/unread-count');
  return res.data.data?.count ?? 0;
};

export const markNotificationRead = async (id: string): Promise<void> => {
  await apiClient.post(`/notifications/${id}/read`);
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await apiClient.post('/notifications/read-all');
};
